import { CommandGetFieldMap } from "./commands/cmdGetFieldMap";
import { CommandSaveFieldMap } from "./commands/cmdSaveFieldMap";
import { CommandGetFileColumns } from "./commands/cmdGetFileColumns";
import { CommandListVerticals } from "./commands/cmdListVerticals";
import { CommandListCoreTargets } from "./commands/cmdListCoreTargets";
import { CommandListEntityTypes } from "./commands/cmdListEntityTypes";
import { CommandListMetrics } from "./commands/cmdListMetrics";
import { CommandListMetricTypes } from "./commands/cmdListMetricTypes";
import { CommandListCoreFieldSamples } from "./commands/cmdListCoreFieldSamples";
import { CommandGenerateConversions } from "./commands/cmdGenerateConversions";
import { CommandGetInstructions } from "./commands/cmdGetInstructions";
import { CommandDownloadSampleFile, SampleFileVariant } from "./commands/cmdDownloadSampleFile";
import { FieldMapDocument } from "@models/fieldMap.model";

export class FieldMapService {
  async getFieldMap(definitionId: number) { return new CommandGetFieldMap().run(definitionId); }
  async saveFieldMap(definitionId: number, doc: FieldMapDocument) { return new CommandSaveFieldMap().run(definitionId, doc); }
  async getFileColumns(definitionId: number) { return new CommandGetFileColumns().run(definitionId); }
  async listVerticals() { return new CommandListVerticals().run(); }
  async listCoreTargets() { return new CommandListCoreTargets().run(); }
  async listEntityTypes(vertical?: string) { return new CommandListEntityTypes().run(vertical); }
  async listMetrics(entityCode: string) { return new CommandListMetrics().run(entityCode); }
  async listMetricTypes() { return new CommandListMetricTypes().run(); }
  async listCoreFieldSamples(verticalCode: string) { return new CommandListCoreFieldSamples().run(verticalCode); }
  async generateConversions(runId: number) { return new CommandGenerateConversions().run(runId); }
  async getInstructions(definitionId: number) { return new CommandGetInstructions().run(definitionId); }
  async downloadSampleFile(definitionId: number, variant: SampleFileVariant, rows = 1, fallbackName?: string) {
    return new CommandDownloadSampleFile().run(definitionId, variant, rows, undefined, fallbackName);
  }
}
